import { Link as GatsbyLink } from "gatsby"
import { Icons } from "../../../types/icons"
import { Link } from "react-bricks/frontend"
import React from "react"
import classNames from "classnames"
import { ContainerType } from "../layout"
import { twMerge } from "tailwind-merge"

export enum TextLinkSize {
    Small = "sm",
    Base = "base",
}

export enum TextLinkColor {
    Blue = "blue",
    White = "white",
}

interface TextLinkProps {
    href?: string
    target?: "_blank" | "_self"
    title: string
    icon?: Icons
    iconDisplay?: boolean
    size?: TextLinkSize
    color?: TextLinkColor
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
    withOnClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
    to?: string
    disabled?: boolean
    bold?: boolean
    type?: ContainerType
}

const TextLink = ({
    href,
    target,
    title,
    iconDisplay = true,
    icon = Icons.link,
    size = TextLinkSize.Base,
    color = TextLinkColor.Blue,
    onClick,
    withOnClick,
    to,
    disabled,
    bold,
    type,
}: TextLinkProps) => {
    const classes = classNames("inline-flex items-center", {
        "text-blue": color === TextLinkColor.Blue,
        "text-white": color === TextLinkColor.White,
        "cursor-not-allowed pointer-events-none opacity-30": disabled,
    })

    const innerContent = (
        <div
            className={twMerge(
                classNames("flex items-center", {
                    "items-start": bold,
                })
            )}
        >
            {iconDisplay && (
                <i
                    className={twMerge(
                        classNames(
                            "lavita-icon mr-2.5 text-md sm:mr-3",
                            !bold
                                ? {
                                      "sm:text-lg lg:text-xl": size === TextLinkSize.Base,
                                      "lg:text-lg": size === TextLinkSize.Small,
                                  }
                                : {
                                      "text-sm sm:text-base lg:text-md": type !== ContainerType.Article,
                                      "text-sm lg:text-base": type === ContainerType.Article,
                                  }
                        )
                    )}
                >
                    {icon}
                </i>
            )}
            <span
                className={classNames(
                    "underline",
                    !bold
                        ? {
                              "text-md sm:text-lg lg:text-xl": size === TextLinkSize.Base,
                              "text-base sm:text-md lg:text-lg": size === TextLinkSize.Small,
                          }
                        : {
                              "font-semibold text-md sm:text-lg lg:text-xl": type !== ContainerType.Article,
                              "font-semibold text-md lg:text-lg": type === ContainerType.Article,
                          }
                )}
            >
                {title}
            </span>
        </div>
    )

    return onClick ? (
        <button type="button" className={classes} onClick={onClick} disabled={disabled}>
            {innerContent}
        </button>
    ) : disabled ? (
        <div className={classes}>{innerContent}</div>
    ) : to ? (
        <GatsbyLink to={to} className={classes} onClick={withOnClick}>
            {innerContent}
        </GatsbyLink>
    ) : href ? (
        <Link
            href={href}
            target={target}
            rel={target === "_blank" ? "noopener noreferrer" : undefined}
            className={classes}
            onClick={withOnClick}
        >
            {innerContent}
        </Link>
    ) : null
}

export default TextLink
